import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Expense, Status, statusValues } from '../../../../liabilities/models/expenses';
import { AppConfig } from '../../../../core/services/app-config.service';
import { PaykaCurrencyPipe } from '../../../utils/pipes/payka-currency.pipe';
import { DatePipe, DecimalPipe, NgClass, NgForOf, NgIf, NgStyle } from '@angular/common';
import { DefermentsService } from '../../../../defer/services/deferments.service';
import { MessageButtons, MessageType } from '../../../models/messages.model';
import { MessagesStoreService } from '../../../services/messages-store.service';
import { saveAs } from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedAgreementsStoreService } from '../../../../core/services/selected-agreements-store.service';
import { Subscription } from 'rxjs';
import { IconComponent } from '../../icon/icon.component';
import { DefaultLayoutAlignDirective, DefaultLayoutDirective } from 'ng-flex-layout';

@Component({
  standalone: true,
  selector: 'app-expanded-detail',
  templateUrl: './expanded-detail.component.html',
  styleUrls: ['./expanded-detail.component.scss'],
  providers: [PaykaCurrencyPipe, DecimalPipe],
  imports: [
    IconComponent,
    NgClass,
    NgStyle,
    PaykaCurrencyPipe,
    DatePipe,
    DefaultLayoutDirective,
    DefaultLayoutAlignDirective,
    NgIf,
    NgForOf,
  ],
})
export class ExpandedDetailComponent implements OnInit, OnDestroy {
  protected readonly statuses = statusValues;
  public result = '';

  @Input() value: Expense;
  private checked: boolean;
  private selectedAgreements$: Subscription;
  checkedInstallments: string[] = [];
  protected readonly Status = Status;

  constructor(private appConfig: AppConfig,
              private defermentsService: DefermentsService,
              private messagesStoreService: MessagesStoreService,
              private selectedAgreementsStoreService: SelectedAgreementsStoreService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.selectedAgreements$ = this.selectedAgreementsStoreService.state$.subscribe(value1 => {
      if (value1 === null || value1.length === 0) {
        this.checked = false;
      } else {
        this.checked = (value1.findIndex(number => number === this.value.contractNumber) > -1);
      }
    });


    var list = this.value.paymentSchedule
      .filter((item) => (item.status === Status.OVERDUE));

    if (list.length === 0) {
      list = this.value.paymentSchedule
        .filter((item) => (item.status === Status.TO_BE_REPAID));
    }

    var numbers = list.map(item => item.installmentNumber.toString());
    this.checkedInstallments.push(...numbers);

    if (this.checkedInstallments.length === 0) {
      let upcomings = this.value.paymentSchedule.filter(item => item.status === Status.UPCOMING);
      var upcomingsNumbers = upcomings.map(item => item.installmentNumber);
      const minInstallmentNumber = Math.min(...upcomingsNumbers.map(item => Number(item)));
      this.checkedInstallments.push(String(minInstallmentNumber));
    }
  }

  ngOnDestroy(): void {
    this.selectedAgreements$.unsubscribe();
  }


  getLinkToRepaymentEntireAgreement() {
    const baseUrl = this.appConfig.config.omega.payByLinkUrl;
    const otherParams = {
      pay_partner: this.appConfig.config.omega.pay_partner,
    };
    const dataParams = `data=${encodeURIComponent(this.value.wcsToken)}`;
    const otherQueryParams = Object.keys(otherParams)
      .map(key => `${key}=${encodeURIComponent(otherParams[key])}`)
      .join('&');

    const queryParams = [dataParams, otherQueryParams].join('&');
    window.location.href = `${baseUrl}?${(queryParams)}`;
  }

  public onDownloadFileClick() {
    this.defermentsService.fetchFile(this.value.contractNumber)
      .subscribe(
        (response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = 'agreement.pdf';
          if (contentDisposition) {
            const matches = /filename="(.+)"/.exec(contentDisposition);
            if (matches && matches[1]) {
              filename = matches[1];
            }
          }
          saveAs(response.body, filename);
        },
        () => this.showErrorMessage(),
      );
  }

  public onGoToDefermentClick() {
    this.router.navigate([this.value.contractNumber], { relativeTo: this.route });
  }

  private showErrorMessage() {
    this.messagesStoreService.setState({
      type: MessageType.ERROR,
      buttons: MessageButtons.CONTACT,
      closeable: true,
      title: 'Błąd',
      msg: 'Wystąpił nieoczekiwany błąd podczas pobierania. ' +
        'Proszę spróbować ponownie później lub skontaktuj się z nami, aby wyjaśnić sprawę.',
    });
  }

  getColor(item) {
    if (item === Status.OVERDUE) {
      return '#C92121';
    } else {
      return '#575481';
    }
  }

  shoudBeChecked(value) {
    return this.checked && (this.checkedInstallments.findIndex(v => v === value.installmentNumber) > -1);
  }

  public isDisabledPaymentLink() {
    return !this.value.token && !this.value.wcsToken;
  }

  public isDisabledDownloadLink() {
    return this.value.status === Status.IN_PROCESS ;
  }

  public isDisabledDetailsLink() {
    return !this.value.accessToDetails;
  }

}
